import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { usePatients } from 'lib/hooks/queries/patients/usePatients';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import Allowed from 'components/shared/Permissions/Allowed';

import HeaderActions from './lib/HeaderActions';
import columns from './lib/columns';
import DEFAULT_FILTERS from './lib/defaultFilters';

export default function Patients() {
  const navigate = useNavigate();
  const { id } = useParams();

  const onRowClicked = (event) => {
    if (event?.id) {
      navigate(`/admin/patients/${event?.id}`);
    }
  };

  return (
    <Allowed requiredPermissions="patients.read" showMessage showIllustration>
      <AgTablePage
        onSelectRow={onRowClicked}
        defaultColumns={columns}
        defaultFilters={DEFAULT_FILTERS}
        useData={usePatients}
        queryParams={{ practiceId: id }}
        rowStyle={{ cursor: 'pointer' }}
        name="patients"
        rightHeaderActions={HeaderActions}
        keepOldFilters
      />
    </Allowed>
  );
}
